import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { map } from 'rxjs';
import { UserApiService } from '../services/api/user-api.service';

export const privacyPolicyGuard: CanDeactivateFn<unknown> = (component, currentRoute, currentState, nextState) => {
  if (nextState.url.startsWith('/logout') || nextState.url.startsWith('/privacy-policy')) {
    return true;
  }
  const userApi = inject(UserApiService);
  return userApi.getUser().pipe(
    map(user => {
      return user.acceptedBookkerPolicy && (user.acceptedCustomPolicy || !user.organization?.modules?.isCustomPolicy());
    }),
  );
};
